import './ValentineDaySticker.sass';

import { FC } from 'react';

import { AnimatedEmoji } from '$uikit';
import { ValentineDayStickerProps } from './ValentineDaySticker.interface';
import { useCurrentUserInfo, useTranslator, useUserInfo } from '$hooks';

const Emoji = ['💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '❤️‍🔥'];

export const ValentineDaySticker: FC<ValentineDayStickerProps> = (props) => {
  const { message } = props;

  const t = useTranslator();
  const curUser = useCurrentUserInfo();
  const selectedEmoji = Emoji[message.id % Emoji.length];
  const isOutbox = curUser.id === message.toId;
  const peer = useUserInfo(message.toId);

  return (
    <div className="ValentineDaySticker">
      <div className="ValentineDaySticker__info">{isOutbox ? t('valentine_day_sticker_info_outbox') : t('valentine_day_sticker_info_inbox', { name: peer.firstName })}</div>
      <AnimatedEmoji emoji={selectedEmoji} loop />
      <div className="ValentineDaySticker__message">{t('valentine_day_sticker_message')}</div>
    </div>
  );
};
